<script setup lang="ts">
interface Step {
  n: string
  title: string
  desc: string
  time: string
  svg: string
}

const steps: Step[] = [
  {
    n: '01',
    title: 'Wybierz pojazd',
    desc: 'Dostawczy, ciężarowy, naczepa. Pokazujemy tylko modele, które naprawdę realizujemy — bez fikcji.',
    time: '~ 2 min',
    svg: `<rect x="6" y="14" width="28" height="22" rx="1"/>
          <path d="M34 20h6l4 6v10h-10z"/>
          <circle cx="14" cy="38" r="3"/><circle cx="38" cy="38" r="3"/>
          <path d="M6 30h28"/>`,
  },
  {
    n: '02',
    title: 'Dobierz zabudowę',
    desc: 'Plandeka, izoterma, chłodnia, kontener, skrzynia. Zmieniasz wymiary i materiały — kalkulacja aktualizuje się na żywo.',
    time: '~ 4 min',
    svg: `<rect x="6" y="10" width="36" height="28" rx="1"/>
          <path d="M6 18h36M14 10v28M22 26h12M22 30h8"/>
          <circle cx="17" cy="24" r="2" fill="currentColor"/>`,
  },
  {
    n: '03',
    title: 'Zatwierdź konfigurację',
    desc: 'Dokumenty generują się automatycznie.',
    time: '~ 1 min',
    svg: `<path d="M24 4l16 8v12c0 10-7 18-16 20-9-2-16-10-16-20V12z"/>
          <path d="M16 24l6 6 12-12"/>`,
  },
  {
    n: '04',
    title: 'Odbierasz pojazd',
    desc: '14 dni od podpisu — gotowy do pracy. Powiadomienia push na każdym etapie produkcji.',
    time: '14 dni',
    svg: `<circle cx="24" cy="24" r="20"/><path d="M24 8v16l10 6"/>`,
  },
]
</script>

<template>
  <section
    id="process"
    class="border-pw-paper bg-pw-ink text-pw-paper border-b px-5 py-16 md:px-14 md:py-24"
  >
    <div class="mx-auto max-w-[1440px]">
      <div
        class="border-pw-paper mb-10 flex flex-col gap-4 border-b pb-5 md:mb-14 md:grid md:grid-cols-[auto_1fr_auto] md:items-end md:gap-8"
      >
        <div
          class="font-mono text-[12px] font-semibold tracking-[0.14em] opacity-50"
        >
          [ 01 / PROCES ]
        </div>
        <h2
          class="font-narrow m-0 text-[clamp(32px,5vw,72px)] leading-[0.95] font-extrabold tracking-[-0.02em]"
        >
          Cztery kroki<br />od pomysłu do kluczyków.
        </h2>
        <div
          class="text-pw-muted hidden max-w-60 text-right font-mono text-[11px] leading-normal tracking-[0.12em] uppercase md:block"
        >
          Każdy etap zajmuje od 2 do 5 minut. Zapisujemy postęp, więc możesz
          wrócić.
        </div>
      </div>

      <div
        class="border-pw-paper bg-pw-paper grid grid-cols-1 gap-px border md:grid-cols-2 lg:grid-cols-4"
      >
        <div
          v-for="step in steps"
          :key="step.n"
          class="group bg-pw-ink hover:bg-pw-line relative flex min-h-[280px] flex-col p-5 pt-6 pb-7 transition-colors md:p-7 md:pt-8 md:pb-9"
        >
          <div
            class="text-pw-muted mb-4 font-mono text-[11px] tracking-[0.14em]"
          >
            /{{ step.n }}
          </div>
          <div
            class="text-pw-dim group-hover:text-pw-ink mb-5 grid h-12 w-12 place-items-center"
          >
            <svg
              viewBox="0 0 48 48"
              fill="none"
              stroke="currentColor"
              stroke-width="1.4"
              class="h-full w-full"
              v-html="step.svg"
            ></svg>
          </div>
          <h3
            class="font-narrow m-0 mb-2.5 text-[28px] leading-[1.05] font-bold tracking-tight"
          >
            {{ step.title }}
          </h3>
          <p class="text-pw-dim m-0 flex-1 text-[14px] leading-normal">
            {{ step.desc }}
          </p>
          <div
            class="border-pw-line text-pw-dim group-hover:border-pw-paper group-hover:text-pw-paper mt-4 flex justify-between border-t border-dashed pt-3.5 font-mono text-[11px]"
          >
            <span>Czas</span><b class="font-semibold">{{ step.time }}</b>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
